'use client';

import { type ComponentType, type PropsWithChildren, createContext, useContext } from 'react';
import { type Logger } from '../models';
import { useLogger } from './useLogger';
const PageLoggerContext = createContext<Logger | undefined>(undefined);
const usePageLoggerContext = () => useContext(PageLoggerContext);
interface PageLoggerPropsWithPageName {
  pageName: string;
  logger?: never;
}
interface PageLoggerPropsWithLogger {
  pageName?: never;
  logger?: Logger;
}
export const PageLogger = ({
  pageName,
  logger,
  children
}: PropsWithChildren<PageLoggerPropsWithPageName | PageLoggerPropsWithLogger>) => {
  const pageLogger = useLogger(pageName ?? '');
  return <PageLoggerContext.Provider value={logger ?? pageLogger} data-sentry-element="PageLoggerContext.Provider" data-sentry-component="PageLogger" data-sentry-source-file="usePageLogger.tsx">{children}</PageLoggerContext.Provider>;
};
export const withPageLogger = <T extends Record<string, unknown>,>(WrappedComponent: ComponentType<T>, pageName: string) => {
  return (props: T) => {
    return <PageLogger pageName={pageName}>
        <WrappedComponent {...props} />
      </PageLogger>;
  };
};
export const usePageLogger = () => {
  return usePageLoggerContext();
};